<script>
import { Line } from "vue-chartjs";

export default {
    extends: Line,
    data: () => ({
        datacollection: {
            // labels: ['2019-03-23', '2019-03-24', '2019-03-25', '2019-03-26',"2019-03-27","2019-03-28","2019-03-29"],
            datasets: [
                // {
                //     backgroundColor: ["rgba(0, 240, 10, 0.05)"],
                //     borderColor: ["#20A39E"]
                //     // borderWidth:[0,0]
                // },
                // {
                //     backgroundColor: ["rgba(232,81,64, 0.05)"],
                //     borderColor: ["#E85140"]
                //     // borderWidth:[0,0]
                // },
                // {
                //     backgroundColor: ["rgba(50,81,64, 0.05)"],
                //     borderColor: ["#508991"]
                //     // borderWidth:[0,0]
                // }
            ]
        },
        chartColor: [
            {
                backgroundColor: ["rgba(0, 240, 10, 0.05)"],
                borderColor: ["#20A39E"]
            },
            {
                backgroundColor: ["rgba(232,81,64, 0.05)"],
                borderColor: ["#E85140"]
            },
            {
                backgroundColor: ["rgba(50,81,64, 0.05)"],
                borderColor: ["#508991"]
            }
        ],
        options: {
            legend: { display: true },
            responsive: true,
            maintainAspectRatio: false,
            showTooltips: false,
            animationEasing: "easeOutQuart",
            animateScale: true,
            scales: {
                yAxes: [
                    {
                        ticks: {
                            beginAtZero: true
                        }
                    }
                ],
                xAxes: [
                    {
                        type: "time",
                        distribution: "linear",
                        time: {
                            unit: "day",
                            unitStepSize: 1,
                            displayFormats: {
                                month: "MMM",
                                day: "MMM DD",
                                year: "YYYY"
                            }
                        }
                    }
                ]
            }
        }
    }),
    methods: {
        render(chartDataCollection) {
            this.datacollection.datasets = [];
            this.options.scales.xAxes[0].time.unit = this.dateInterval.prop;

            chartDataCollection.forEach((chartData, index) => {
                this.datacollection.datasets.push({
                    label: chartData.title,
                    data: chartData.data,
                    backgroundColor:[this.chartColor[index].backgroundColor],
                    borderColor:[this.chartColor[index].borderColor]
                });
            });

            this.renderChart(this.datacollection, this.options);
            // this.$data._chart.update();
        },
        update() {
            this.$data._chart.update();
        }
    },
    // watch: {
    //     dateInterval() {
    //         this.options.scales.xAxes[0].time.unit = this.dateInterval.prop;
    //         this.renderChart(this.datacollection, this.options);
    //     },
    // },
    mounted() {
        // this.options.scales.xAxes[0].time.unit = this.dateInterval.prop;
        // this.renderChart(this.datacollection, this.options);
    },
    props: ["dateInterval"]
};
</script>






